module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/column-visibility/column-visibility.component.css
// module id = ./src/app/examples/column-visibility/column-visibility.component.css
// module chunks = main